import { Component, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AccessibilityService } from '../../services/accessibility.service';

@Component({
	selector: 'app-warning-phone-modal',
	templateUrl: './warning-phone-modal.component.html',
	styleUrls: ['./warning-phone-modal.component.scss'],
})
export class WarningPhoneModalComponent {
	dialogRef: MatDialogRef<WarningPhoneModalComponent>;

	constructor(
		dialogRef: MatDialogRef<WarningPhoneModalComponent>,
		private el: ElementRef,
		private renderer: Renderer2,
		private readonly accessibilityService: AccessibilityService,
	) {
		this.dialogRef = dialogRef;
	}

	ngOnInit(): void {
		if (this.accessibilityService.getAccessibility())
			this.renderer.addClass(this.el.nativeElement, 'modal-accessibility');
	}
}
